// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".productCard_O0h9c{width:230px;min-height:200px}@media(min-width:1024px){.productCard_O0h9c{width:315px}}", ""]);
// Exports
exports.locals = {
	"productCard": "productCard_O0h9c"
};
module.exports = exports;
